function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-1",
  x: 8.200681,
  y: 124.617835
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-2",
  x: 82.605367,
  y: 124.617835
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-3",
  x: 157.010052,
  y: 124.617835
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-4",
  x: 231.414749,
  y: 124.617835
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-5",
  x: 305.819423,
  y: 124.617835
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-1",
  x: -5.224113,
  y: 116.867026
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-2",
  x: 69.180573,
  y: 116.867026
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-3",
  x: 143.585258,
  y: 116.867026
});

var _ref10 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-4",
  x: 217.989955,
  y: 116.867026
});

var _ref11 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-5",
  x: 292.394629,
  y: 116.867026
});

var _ref12 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-1",
  x: 1.488284,
  y: 120.742431
});

var _ref13 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-2",
  x: 75.89297,
  y: 120.742431
});

var _ref14 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-3",
  x: 150.297655,
  y: 120.742431
});

var _ref15 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-4",
  x: 224.702352,
  y: 120.742431
});

var _ref16 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-5",
  x: 299.107026,
  y: 120.742431
});

function SvgNameBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "149.999998pt",
    viewBox: "0 0 375 149.999998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.15625 0 L 11.15625 -89.296875 L 63.25 -89.296875 L 63.25 0 Z M 19.84375 -6.203125 L 57.046875 -6.203125 L 57.046875 -75.78125 Z M 54.5625 -83.09375 L 17.359375 -83.09375 L 17.359375 -13.515625 Z M 54.5625 -83.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 23.8125 -89.296875 L 23.8125 -52.703125 L 50.71875 -52.703125 L 50.71875 -89.296875 L 64.234375 -89.296875 L 64.234375 0 L 50.71875 0 L 50.71875 -40.1875 L 23.8125 -40.1875 L 23.8125 0 L 10.171875 0 L 10.171875 -89.296875 Z M 23.8125 -89.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.9375 -19.46875 C 6.9375 -26.082031 9.226562 -31.3125 13.8125 -35.15625 C 18.40625 -39 24.628906 -40.921875 32.484375 -40.921875 L 50.96875 -40.921875 L 50.96875 -46.75 C 50.96875 -50.382812 49.707031 -53.234375 47.1875 -55.296875 C 44.664062 -57.367188 41.085938 -58.40625 36.453125 -58.40625 C 32.898438 -58.40625 29.882812 -57.742188 27.40625 -56.421875 C 24.925781 -55.097656 23.316406 -53.28125 22.578125 -50.96875 L 9.046875 -50.96875 C 10.128906 -56.675781 13.148438 -61.179688 18.109375 -64.484375 C 23.066406 -67.796875 29.222656 -69.453125 36.578125 -69.453125 C 45.265625 -69.453125 52.109375 -67.46875 57.109375 -63.5 C 62.109375 -59.53125 64.609375 -54.070312 64.609375 -47.125 L 64.609375 0 L 51.96875 0 L 51.96875 -13.265625 L 50.96875 -13.265625 C 50.0625 -8.804688 47.625 -5.273438 43.65625 -2.671875 C 39.6875 -0.0664062 34.890625 1.234375 29.265625 1.234375 C 22.398438 1.234375 16.960938 -0.625 12.953125 -4.34375 C 8.941406 -8.0625 6.9375 -13.101562 6.9375 -19.46875 Z M 33.359375 -9.671875 C 35.835938 -9.671875 38.148438 -10 40.296875 -10.65625 C 42.453125 -11.320312 44.3125 -12.253906 45.875 -13.453125 C 47.445312 -14.648438 48.6875 -16.054688 49.59375 -17.671875 C 50.507812 -19.285156 50.96875 -21.039062 50.96875 -22.9375 L 50.96875 -31.5 L 32.609375 -31.5 C 28.890625 -31.5 25.957031 -30.546875 23.8125 -28.640625 C 21.664062 -26.742188 20.59375 -24.0625 20.59375 -20.59375 C 20.59375 -17.113281 21.707031 -14.421875 23.9375 -12.515625 C 26.164062 -10.617188 29.304688 -9.671875 33.359375 -9.671875 Z M 33.359375 -9.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 34.84375 1.234375 C 27.238281 1.234375 21.054688 -0.394531 16.296875 -3.65625 C 11.546875 -6.925781 8.84375 -11.410156 8.1875 -17.109375 L 22.328125 -17.109375 C 22.816406 -14.878906 24.195312 -13.101562 26.46875 -11.78125 C 28.75 -10.457031 31.539062 -9.796875 34.84375 -9.796875 L 39.3125 -9.796875 C 43.363281 -9.796875 46.523438 -10.625 48.796875 -12.28125 C 51.066406 -13.9375 52.203125 -16.207031 52.203125 -19.09375 C 52.203125 -24.0625 48.566406 -27.039062 41.296875 -28.03125 L 31.375 -29.390625 C 24.019531 -30.296875 18.582031 -32.398438 15.0625 -35.703125 C 11.550781 -39.015625 9.796875 -43.648438 9.796875 -49.609375 C 9.796875 -55.890625 12.003906 -60.765625 16.421875 -64.234375 C 20.847656 -67.710938 27.15625 -69.453125 35.34375 -69.453125 L 39.6875 -69.453125 C 46.875 -69.453125 52.71875 -67.859375 57.21875 -64.671875 C 61.726562 -61.492188 64.398438 -57.175781 65.234375 -51.71875 L 51.21875 -51.71875 C 50.71875 -53.78125 49.4375 -55.410156 47.375 -56.609375 C 45.3125 -57.804688 42.75 -58.40625 39.6875 -58.40625 L 35.34375 -58.40625 C 31.457031 -58.40625 28.476562 -57.679688 26.40625 -56.234375 C 24.34375 -54.796875 23.3125 -52.628906 23.3125 -49.734375 C 23.3125 -47.335938 24.078125 -45.476562 25.609375 -44.15625 C 27.140625 -42.832031 29.597656 -41.960938 32.984375 -41.546875 L 43.15625 -40.1875 C 50.925781 -39.101562 56.628906 -36.90625 60.265625 -33.59375 C 63.910156 -30.289062 65.734375 -25.582031 65.734375 -19.46875 C 65.734375 -12.851562 63.457031 -7.75 58.90625 -4.15625 C 54.363281 -0.5625 47.832031 1.234375 39.3125 1.234375 Z M 34.84375 1.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.796875 -90.53125 L 23.4375 -90.53125 L 23.4375 -68.203125 C 23.4375 -67.046875 23.394531 -65.785156 23.3125 -64.421875 C 23.226562 -63.054688 23.125 -61.773438 23 -60.578125 C 22.875 -59.378906 22.789062 -58.382812 22.75 -57.59375 C 22.707031 -56.8125 22.6875 -56.421875 22.6875 -56.421875 L 23.8125 -56.421875 C 24.71875 -60.554688 26.757812 -63.757812 29.9375 -66.03125 C 33.125 -68.3125 37.160156 -69.453125 42.046875 -69.453125 C 45.429688 -69.453125 48.507812 -68.867188 51.28125 -67.703125 C 54.050781 -66.546875 56.40625 -64.894531 58.34375 -62.75 C 60.289062 -60.601562 61.800781 -58.019531 62.875 -55 C 63.945312 -51.976562 64.484375 -48.609375 64.484375 -44.890625 L 64.484375 0 L 50.96875 0 L 50.96875 -43.03125 C 50.96875 -47.664062 49.75 -51.285156 47.3125 -53.890625 C 44.875 -56.492188 41.546875 -57.796875 37.328125 -57.796875 C 33.023438 -57.796875 29.632812 -56.429688 27.15625 -53.703125 C 24.675781 -50.972656 23.4375 -47.25 23.4375 -42.53125 L 23.4375 0 L 9.796875 0 Z M 9.796875 -90.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.90625 0 L 10.90625 -12.40625 L 35.59375 -12.40625 L 35.59375 -55.9375 L 14.015625 -55.9375 L 14.015625 -68.203125 L 48.734375 -68.203125 L 48.734375 -12.40625 L 68.828125 -12.40625 L 68.828125 0 Z M 39.0625 -94.875 L 41.921875 -94.875 C 44.484375 -94.875 46.546875 -94.148438 48.109375 -92.703125 C 49.679688 -91.253906 50.46875 -89.332031 50.46875 -86.9375 C 50.46875 -84.539062 49.679688 -82.640625 48.109375 -81.234375 C 46.546875 -79.828125 44.484375 -79.125 41.921875 -79.125 L 39.0625 -79.125 C 36.5 -79.125 34.453125 -79.828125 32.921875 -81.234375 C 31.390625 -82.640625 30.625 -84.539062 30.625 -86.9375 C 30.625 -89.332031 31.390625 -91.253906 32.921875 -92.703125 C 34.453125 -94.148438 36.5 -94.875 39.0625 -94.875 Z M 39.0625 -94.875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,100%)",
      fillOpacity: 1
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,100%)",
      fillOpacity: 1
    }
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,100%)",
      fillOpacity: 1
    }
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,100%)",
      fillOpacity: 1
    }
  }, _ref5), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,100%)",
      fillOpacity: 1
    }
  }, _ref6), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,100%)",
      fillOpacity: 1
    }
  }, _ref7), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,100%)",
      fillOpacity: 1
    }
  }, _ref8), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,100%)",
      fillOpacity: 1
    }
  }, _ref9), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,100%)",
      fillOpacity: 1
    }
  }, _ref10), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,100%)",
      fillOpacity: 1
    }
  }, _ref11), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _ref12), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _ref13), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _ref14), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _ref15), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _ref16)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameBlack);
export default __webpack_public_path__ + "static/media/name-black.51a01892.svg";
export { ForwardRef as ReactComponent };